import { css } from 'linaria';
const loaderCentered = "ljtooo1";
export const LoaderCentered = ({
  children
}) => <div className={loaderCentered}>{children}</div>;
const loadMore = "l5s94ur";
export const LoadMore = ({
  children
}) => <div className={loadMore}>{children}</div>;
const loadWrapper = "lmrglvq";
export const Loader = () => {
  return <div className={loadWrapper}>
      <div className="spin circle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6">
          <circle cx="3" cy="3" r="3" />
        </svg>
      </div>
      <div className="spin triangle">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M24 22H0L12 2z" />
        </svg>
      </div>
      <div className="spin square">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 6">
          <path d="M0 0h6v6H0z" />
        </svg>
      </div>
    </div>;
};

require("./loader.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./loader.js");